import React, { memo, useContext } from 'react'
import copy from 'copy-to-clipboard'
import CopyIcon from 'transfix-icons/build/CopyIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { ShareLoadContext } from 'apps/fleet-planner/context'

interface IShareLoadLinkPreviewProps {
  url?: string
  message?: string
}

export const ShareLoadLinkPreview = memo<IShareLoadLinkPreviewProps>(({ url = '' }) => {
  const { pushNewToastMessage } = useContext(ShareLoadContext)
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsOneTimeSmsLoadShareEnabled } = getFlag('fmsOneTimeSmsLoadShare')
  const copyTextHandler = () => {
    copy(url)
    pushNewToastMessage('Link copied to clipboard')
  }

  return (
    <div className='share-load-link-preview'>
      <div className='body-small mb1'>Link included with this message</div>
      {url && (
        <div>
          <a href={url} target='_blank' rel='noreferrer'>
            {url.replace('https://', '')}
          </a>
          {isFmsOneTimeSmsLoadShareEnabled && (
            <IconButton
              onClick={copyTextHandler}
              Icon={CopyIcon}
              label='Copy URL'
              color='secondary'
              data-test='copy-share-button'
              size='large'
            />
          )}
        </div>
      )}
    </div>
  )
})
